import { AdditionalVisualDescription } from 'Components/Worksheets/Core/Fields';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { SieveAdditionFieldSet } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components/SieveAdditionFieldSet';
import { cumulativeOptions } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { ISieveSize, SieveSizeId, getById } from 'Data/ViewModels/Equipment/ISieveSize';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, RadioGroup, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection } from '../../../../../../Layout';
import { ManageSeparationsButton } from '../../../../Components';
import { getNumberOfSeparations, getSeparationSieveSizeIds } from '../../../../Helpers';

let TestPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isManageSeparationsDisabled = useSelector(
    pipe(createWorksheetSelector!('Preparation.Method'), (m) => m === 'B')
  );
  const anySeparations = useSelector(pipe(createWorksheetSelector!('', false), getNumberOfSeparations, (n) => n > 0));

  const separatingSievesList = useSelector(
    combine(
      [
        pipe(createWorksheetSelector!('', false), getSeparationSieveSizeIds),
        createWorksheetSelector!('Equipment.AllSieveSizes'),
      ],
      (ids: SieveSizeId[], allSieves: ISieveSize[]) =>
        ids.length > 0 ? ids.map((id: SieveSizeId) => getById(allSieves, id)?.Caption ?? 'Not set').join(', ') : 'None'
    )
  );
  const allowVisualDescriptionEntry = useSelector(
    createWorksheetSelector!('Preparation.AllowAdditionalVisualDescriptionEntry')
  );

  const sieveNo4Caption = useSelector(
    pipe(
      createWorksheetSelector!('Equipment.AllSieveSizes'),
      (ss: ISieveSize[]) => ss.find((s) => s.Id === '4_75'),
      (s) => s?.Caption
    )
  );

  return (
    <PageSection heading="Test Preparation">
      <NamePrefixModifier appendNamePrefix="Preparation">
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            label="Method"
            name="Method"
            options={[
              { label: 'A - Nearest 1%', value: 'A' },
              { label: `B - Nearest 0.1%, Max ${sieveNo4Caption} particle size`, value: 'B', disabled: anySeparations },
            ]}
          />
          <Field
            input={<RadioGroup />}
            label="Sieve Retained Masses Are"
            name="AreSieveMassesCumulative"
            options={cumulativeOptions}
          />
          <Field
            input={<RadioGroup />}
            label="Pan Masses Are"
            name="ArePanMassesCumulative"
            options={cumulativeOptions}
          />
          <SieveAdditionFieldSet />
        </ListFieldSection>
        <ListFieldSection>
          <FieldSet>
            <Field input={<TextOutput />} label="Separating Sieve(s)" value={separatingSievesList} />
            <div>
              <ManageSeparationsButton maxSeparations={2} disabled={isManageSeparationsDisabled} />
            </div>
          </FieldSet>
          <AdditionalVisualDescription editable visible={allowVisualDescriptionEntry} />
        </ListFieldSection>
      </NamePrefixModifier>
    </PageSection>
  );
};

TestPreparationPageSection = withInjectedProps(TestPreparationPageSection);

export { TestPreparationPageSection };
export default TestPreparationPageSection;
